import type { PropsWithClassName } from '@fv/client-types'

import { InputGroupWrapper } from '@/components/inputs/InputGroup'

import { GLCodeSelector } from '../gl-codes/GLCodeSelector'
import { useAccountSettings } from '../settings/account-settings/hooks'
import { useBookingFormCtx } from './BookingFormProvider'

export const BookingFormGLCode = ({ className }: PropsWithClassName) => {
  const glCode = useBookingFormCtx(s => s.glCode)
  const setGLCode = useBookingFormCtx(s => s.actions.setGLCode)
  const accountSettings = useAccountSettings()
  const required = accountSettings?.glCode?.required

  if (!accountSettings?.glCode?.enabled) return null

  return (
    <InputGroupWrapper
      className={className}
      label="GL Code"
      name="glCode"
      required={required}
    >
      <GLCodeSelector value={glCode} onChange={setGLCode} required={required} />
    </InputGroupWrapper>
  )
}
